<template>
  <div class="container-listado-socios">
    <div class="contenedor-buscador-tabla-botonera">
      <div>
        <BaseLoader
          v-if="cargando"
        />
        <div v-else>
          <div class="contenedor_socios_lista" >
            <!-- <button
              class="boton_exportar"
              @click="exportData"
            >
              Exportar a Excel
            </button> -->
            <table id="tabla-anotados-lista">
              <thead>
                <th class="column_1">Nombre</th>
                <th class="column_1">Apellido</th>
                <th class="column_5">Email</th>
                <th class="column_1">Celular</th>
                <th class="column_5">Mentor</th>
                <th class="column_4"></th>
              </thead>
              <tbody>
                <AnotadosMesaExamenListaItem
                  v-for="socio in sociosPaginado"
                  :socio="socio"
                  :key="socio.persona_id"
                ></AnotadosMesaExamenListaItem>
              </tbody>
            </table>
          </div>
          <!-- <div class="contenedor_paginado" v-if="this.socios.length > 20">
            <button
              :disabled="currentPage === 1"
              @click="prevPage"
              :class="{ disabled: currentPage === 1 }"
              class="boton_paginado boton_paginado_anterior"
            >
              Anterior
            </button>
            <div class="contenedor_botones_paginado">
              <button
                v-for="pageNumber in pageCount"
                :key="pageNumber"
                :class="{ pagina_activa: currentPage === pageNumber }"
                class="boton_paginado_numerico"
                @click="goToPage(pageNumber)"
              >
                {{ pageNumber }}
              </button>
            </div>
            <button
              :disabled="currentPage === pageCount"
              :class="{ disabled: currentPage === pageCount }"
              @click="nextPage"
              class="boton_paginado boton_paginado_siguiente"
            >
              Siguiente
            </button>
          </div> -->
          <!-- <div class="contenedor_paginado" v-if="this.socios.length > 20">
            <button
              @click="firstPage"
              class="boton_paginado_numerico salto_fin_principio"
            >
              <span>&#8739;</span>
              <span>&#60;</span>
            </button>
            <button
              :disabled="currentPage === 1"
              @click="prevPage"
              :class="{ disabled: currentPage === 1 }"
              class="boton_paginado_numerico boton_paginado_anterior"
            >
              <span>&#60;</span>
            </button>
            <button
              v-for="pageNumber in bulletsPaginado"
              :key="pageNumber"
              :class="{ pagina_activa: currentPage === pageNumber }"
              class="boton_paginado_numerico"
              @click="goToPage(pageNumber)"
            >
              {{ pageNumber }}
            </button>
            <div
              v-if="this.mostrarLastPageBullets"
              class="paginado_contenedor_puntitos"
            >
              <span> .... </span>
              <button
                class="boton_paginado_numerico"
                @click="goToPage(pageCount)"
              >
                {{ pageCount }}
              </button>
            </div>
            <button
              :disabled="currentPage === pageCount"
              :class="{ disabled: currentPage === pageCount }"
              @click="nextPage"
              class="boton_paginado_numerico boton_paginado_siguiente"
            >
              <span>&#62;</span>
            </button>
            <button
              @click="lastPage"
              class="boton_paginado_numerico boton_paginado_anterior"
            >
              <span>&#62;</span>
              <span>&#8739;</span>
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnotadosMesaExamenListaItem from '../components/AnotadosMesaExamenListaItem.vue'
import examenService from '../services/examen'
import BaseLoader from '../components/BaseLoader.vue'
const XLSX = require('xlsx')
export default {
  name: 'SociosLista',
  components: {
    AnotadosMesaExamenListaItem,
    BaseLoader
  },
  data: function () {
    return {
      servicio_id: 25,
      selected: {
        perfil_id: [],
        certificacion_id: [],
        socio_id: [],
        condicion_id: [],
        tipo_id: [],
        web_id: [],
        estudio_nombre_1: [],
        dni: [],
        provincia_id_1: [],
        toma_clase: []
      },
      archivo: [],
      socios: ['q'],
      perfiles: [],
      certificaciones: [],
      estados: [],
      condiciones: [],
      tipos: [],
      web: [],
      paginado: [],
      mostrarLastPageBullets: true,
      busqueda: null,
      cargando: false,
      pageNumber: 1,
      currentPage: 1,
      pageCount: 0,
      listData: {
        type: Array,
        required: true
      },
      sizePaginado: 30,
      sizeBulletPaginado: 5
    }
  },
  methods: {
    exportData () {
      const data = this.archivo
      // const data = [{ foo: 'foo' }, { bar: 'bar' }]
      // const fileName = 'Listado_de_Pagos'
      // const exportType = 'csv'
      // exportFromJSON({ data, fileName, exportType })
      // exportFromJSON({ data, exportType })
      const workSheet = XLSX.utils.json_to_sheet(data)
      const workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Listado_de_Socios')
      XLSX.writeFile(workBook, 'Listado_de_Socios.xlsx')
    },
    exportarExcel (data) {
      console.log('dsdsddddddd')
      this.archivo = []
      for (var j = 0; j < data.length; j++) {
        const obj = {}
        // obj.Nombre = this.fechaFormato(this.socios[j].nombre)
        // obj.Apellido = this.socios[j].persona.nombre + ' ' + this.socios[j].persona.apellido
        // obj.Monto = this.socios[j].precio_total
        obj.Nombre = data[j].nombre
        obj.Apellido = data[j].apellido
        obj.Perfil = data[j].perfil
        obj.Certificacion = data[j].certificacion
        obj.DNI = data[j].dni
        obj.Email = data[j].email
        obj.Celular = data[j].celular
        obj.Domicilio = data[j].direccion
        obj.Direccion_Completa = data[j].direccion_completa
        obj.Fecha_De_Ingreso = data[j].fecha_ingreso
        obj.Toma_Clase = data[j].toma_clase
        obj.Estado = data[j].condicion
        obj.Condicion_Alta = data[j].condicion_alta
        obj.Nombre_Estudio_1 = data[j].estudio_nombre_1
        obj.Nombre_Estudio_2 = data[j].estudio_nombre_2
        obj.Mentorias = this.socios[j].mentorias[0]
        // obj.Concepto = this.socios[j].concepto.nombre + ' ' + this.socios[j].years[0].year
        // obj.Descripción = this.socios[j].descripcion
        this.archivo.push(obj)
      }
    },
    buscador (busqueda) {
      this.cargando = true
      this.selected.perfil_id = []
      this.selected.certificacion_id = []
      this.selected.socio_id = []
      this.selected.tipo_id = []
      this.selected.web_id = []
      this.selected.estudio_nombre_1 = []
      this.selected.dni = []
      this.selected.provincia_id_1 = []
      this.selected.toma_clase = []
      if (busqueda === '') {
        examenService
          .traerSociosTodos()
          .then(respuesta => {
            this.cargando = false
            this.currentPage = 1
            this.socios = []
            this.socios = respuesta
            console.log('Todas los socios por buscador', respuesta)
            console.log(this.socios)
            this.pageCount = Math.ceil(this.socios.length / this.sizePaginado)
            console.log(this.pageCount)
            this.exportarExcel(respuesta)
          })
        return
      }
      examenService
        .traerSociosPorBuscador(busqueda)
        .then(respuesta => {
          this.cargando = false
          this.currentPage = 1
          this.socios = []
          this.socios = respuesta
          console.log('Todas los socios 2222', respuesta)
          console.log(this.socios)
          console.log(this.socios.length)
          this.pageCount = Math.ceil(this.socios.length / this.sizePaginado)
          console.log(this.pageCount)
          this.exportarExcel(respuesta)
        })
    }
  },
  computed: {
    sociosPaginado: function () {
      const start = (this.currentPage - 1) * this.sizePaginado
      const end = start + this.sizePaginado
      return this.socios.slice(start, end)
    },
    bulletsPaginado: function () {
      const start = Math.floor((this.currentPage - 1) / this.sizeBulletPaginado) * this.sizeBulletPaginado
      const end = start + this.sizeBulletPaginado
      if (this.pageCount - start < this.sizeBulletPaginado) {
        return this.paginado.slice(this.pageCount - this.sizeBulletPaginado, this.pageCount)
      } else {
        return this.paginado.slice(start, end)
      }
    }
  },
  mounted: function () {
    this.cargando = true
    examenService
      .traerAnotadosMesaDeExamenPorServicioId(this.servicio_id)
      .then(respuesta => {
        this.cargando = false
        console.log('Anotados: ', respuesta)
        this.socios = respuesta
      })
  }
}
</script>

<style>
.buscador {
/*  width: 500px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;*/
  background-image: url('../assets/lupa.png');
/*  background-repeat: no-repeat;
  background-position-y: center;
  text-indent: 40px;
  outline: none;
  margin: 20px 0;
  padding: 12px;*/
}

.buscador:focus {
/*  border-radius: 4px;
  border: 1px solid rgb(126,220,217);*/
  background-image: url('../assets/lupa_focus.png');
}
</style>
